import { render, staticRenderFns } from "./Materijali.vue?vue&type=template&id=f131ec8a&scoped=true"
import script from "./Materijali.vue?vue&type=script&lang=js"
export * from "./Materijali.vue?vue&type=script&lang=js"
import style0 from "./Materijali.vue?vue&type=style&index=0&id=f131ec8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f131ec8a",
  null
  
)

export default component.exports